$(function () {
    "use strict";

    $(document).on('Form::Success', function(event, data, $form) {
        if ($form.hasClass('lp-for-vk__sign-in')) {
            if (_(data).isString() && /^redirect:/.test(data)) {
                document.location = data.replace(/^redirect:/, '');
            }

            if (_(jQuery.parseJSON(data)).isObject()) {
                var json = jQuery.parseJSON(data);
                _(json).each(function(value, key) {
                    var error = value;
                    var $input = $form.find('[name*=' + key.replace('user_', '') + ']');
                    $(document).trigger('Form::RenderError', [$input, [error]]);
                });
            }
        }
    })
});